import { ContentSafety } from '@/docs-partials/clips';
import * as React from 'react';
export default {
  ContentSafety,
  React
};